import React from 'react';
import ReactDOM from 'react-dom/client';
import { Layout } from './Layout'
import { BrowserRouter } from "react-router-dom";
import './i18n'; //lang


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Layout/>
    </BrowserRouter>
   
   {/* <RouterProvider router={router} /> */}
  </React.StrictMode>
);

